<template>
  <div class="wrapper" :style="{ minHeight: windowHeight }">
    <div class="r-header">
      <!--<a href="/">
        <img
          alt="中国中医AI舌诊开放平台"
          class="logo"
          src="https://labelsys-images.oss-cn-hangzhou.aliyuncs.com/tongueFile/portal/2019/04/3b3d18ae-f237-4ee1-9862-394c322c5c98.png"/>
        <img
          alt="中国中医AI舌诊开放平台"
          class="logo"
          src="https://labelsys-images.oss-cn-hangzhou.aliyuncs.com/tongueFile/portal/2019/05/6dc84d14-9a4f-4d66-a6a9-aa78cc1266bb.png"/>
      </a>-->
      <el-button type="text" @click="toHome">返回首页</el-button>
    </div>
    <div class="t-title">
      <h1>AI 舌诊对接</h1>
    </div>

    <!--    账号密码登录-->
    <div class="r-wrap" v-show="!showCorpList && curLoginMode==='password'">
      <div class="r-topbar">
        <div class="r-topbar-con">
          <div class="r-area-tit">
            <h2>账号密码登录</h2>
          </div>
        </div>
        <div class="r-topbar-end">
          <a @click="switchToWechat">使用微信扫码登录<span class="el-icon-arrow-right"/></a>
        </div>
      </div>
      <div class="r-content">
        <div class="login-form-wrap">
          <el-form ref="loginForm" :model="loginForm" :rules="loginRules" @keyup.enter.native="onClickLogin">
            <el-form-item prop="username">
              <el-input
                :maxlength="15"
                :placeholder="$t('login.username')"
                name="username"
                size="large"
                v-inputLoginName
                v-model="loginForm.username"/>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                :placeholder="$t('login.password')"
                name="password"
                size="large"
                type="password"
                v-model="loginForm.password"/>
            </el-form-item>
            <el-form-item>
              <el-button class="login-btn" type="primary" @click="onClickLogin">{{$t('login.login') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!--    微信扫码登录-->
    <div class="r-wrap" v-show="!showCorpList && curLoginMode==='wechat'">
      <div class="r-topbar">
        <div class="r-topbar-end">
          <a @click="curLoginMode='password'">使用账号密码登录<span class="el-icon-arrow-right"/></a>
        </div>
        <div class="r-topbar-con">
          <div class="r-area-tit">
            <h2>微信扫码登录</h2>
          </div>
        </div>
      </div>
      <div class="r-content">
        <div class="login-form-wrap">
          <div class="qrcode_container" id="qrcode_container"/>
        </div>
      </div>
    </div>

    <!--    选择企业-->
    <div class="r-wrap" v-show="showCorpList">
      <div class="r-topbar">
        <div class="r-topbar-end">
          <a @click="reLogin">重新登录<span class="el-icon-arrow-right"/></a>
        </div>
        <div class="r-topbar-con">
          <div class="r-area-tit">
            <h2>请选择企业</h2>
          </div>
        </div>
      </div>
      <div class="r-content">
        <div class="login-form-wrap">
          <ul class="list-items">
            <li :key="corp.corpNo" @click="onLoginSuccess(corp.corpNo)" class="list-item" v-for="corp in corpList">
              {{ corp.corpName }}<span class="el-icon-arrow-right"/>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="r-wrap-after">
      <el-link @click="goToRegister">没有账号？点此注册<span class="el-icon-arrow-right"/></el-link>
      <div class="message-wrap">
        <span class="message">若登录异常，可查阅</span>
        <el-link href="https://www.ai-tongue.com/doc/start/register.html" target="_blank">帮助文档</el-link>
      </div>
    </div>
    <div class="lg-footer">
      <div class="copyright">
        <p class="tag-line">© {{ new Date().getFullYear() }} 合肥云诊信息科技有限公司 版权所有</p>
      </div>
    </div>

    <!--    拼图验证码-->
    <transition name="fade">
      <jigsaw-captcha
        :login="loginCaptcha"
        :register="registerCaptcha"
        @close="onCloseCaptcha"
        ref="captcha"
        v-if="showCaptcha"/>
    </transition>
  </div>
</template>

<script>
import JigsawCaptcha from '@/components/Captcha/Jigsaw/index'
import {register} from '@/api/system/auth/jigsawCaptcha'
import {removeStore, setStore} from '@/utils/store'
import judgeUserInfo from '@/views/login/judgeUserInfo'
import {getCurrentUserInfo} from '@/api/corporation/user'
import {mapGetters} from 'vuex'
import loadQRCode from '@/views/login/wx-login/loadQRCode'

export default {
  name: 'Login',
  components: {JigsawCaptcha},
  mixins: [judgeUserInfo],
  data() {
    return {
      windowHeight: '937px',
      corpList: [],
      showCorpList: false,
      curLoginMode: 'wechat', // wechat,password
      loginForm: {username: '', password: ''},
      loginRules: {
        username: [{required: true, message: '请输入登录名', trigger: 'blur'}],
        password: [{required: true, message: '请输入密码', trigger: 'blur'}]
      },
      showCaptcha: false,
      entranceRouter: '/corporation/home/dashboard'
    }
  },
  computed: {
    ...mapGetters(['loginData', 'loginActive', 'corpUserInfo', 'routes'])
  },
  created() {
    this.$store.commit('SET_LOGIN_TYPE', 'cu')
  },
  mounted: function () {
    this.windowHeight = window.innerHeight + 'px'
    window.onresize = () => {
      return (() => {
        this.windowHeight = window.innerHeight + 'px'
      })()
    }

    // 验证是否有登录数据
    let loginData = this.loginData
    if (loginData && loginData.length > 0) {
      this.onLoginSuccessPre(true)
      return
    }
    this.initWechat()
  },
  methods: {
    /**
     * 初始化微信扫码登录
     */
    initWechat() {
      if (this.curLoginMode === 'wechat') {
        setStore({name: 'wxLogin_fromUrl', content: this.$route.path})
        setStore({name: 'wxLogin_redirectUrl', content: this.entranceRouter})
        loadQRCode()
      } else {
        removeStore({name: 'wxLogin_fromUrl'})
        removeStore({name: 'wxLogin_redirectUrl'})
        document.getElementById('qr-code-container').innerHTML = ''
      }
    },
    /**
     * 切换到微信扫码登录
     */
    switchToWechat() {
      this.curLoginMode = 'wechat'
      this.initWechat()
    },
    /**
     * 账号密码登录
     */
    onClickLogin() {
      this.$refs.loginForm.validate((validated) => {
        if (!validated) {
          return false
        }
        this.showCaptcha = true
      })
    },
    /**
     * 注册拼图验证码
     */
    registerCaptcha() {
      return new Promise((resolve, reject) => {
        register().then((resp) => {
          resolve(resp.data)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    /**
     * 拼图验证码登录
     */
    loginCaptcha(token, sliceX) {
      return new Promise((resolve, reject) => {
        // 清除缓存
        this.$store.dispatch('FedLogOut').then((resp) => {
            let form = {
              username: this.loginForm.username,
              password: this.$md5(this.loginForm.password),
              token: token,
              sliceX: sliceX,
              entrance: 'PC AI舌诊对接系统'
            }
            this.$store.dispatch('jigsawCaptchaLogin', form).then((respData) => {
                if (respData.code === 0) {
                  // 判断登录用户是否存在
                  this.judgeLoginUserInfo().then(() => {
                    this.onLoginSuccessPre()
                    let _this = this
                    setTimeout(() => _this.onCloseCaptcha(), 200)
                  }).catch((e) => {
                    this.$message({type: 'error', showClose: true, message: e.message})
                    this.onCloseCaptcha()
                  })
                }
                resolve(respData)
              }, (e) => {
                reject(e)
              }
            )
          }, (e) => {
            reject(e)
          }
        )
      })
    },
    /**
     * 关闭拼图验证码
     */
    onCloseCaptcha() {
      this.showCaptcha = false
    },
    /**
     * 登录成功预处理
     */
    onLoginSuccessPre() {
      let loginData = this.loginData
      if (!loginData || loginData.length <= 0) {
        return
      }
      // 用户所属企业只有一个时，直接选择
      if (loginData.length === 1) {
        this.onLoginSuccess(loginData[0].corpNo)
        return
      }
      // 选择企业
      this.corpList = loginData
      this.showCorpList = true
      this.$store.commit('SET_LOGIN_ACTIVE', 2)
    },
    /**
     * 登录成功
     */
    onLoginSuccess(corpNo) {
      if (!corpNo) {
        return
      }
      this.$store.commit('SET_LOGIN_ACTIVE', 1)
      this.$store.commit('SET_LOGIN_DATA', null)
      getCurrentUserInfo(corpNo, true).then((resp) => {
        let data = resp.data
        if (data && data.code === 0) {
          if (data.data.corpDisable === 1) {
            this.onCorpDisabled(data.data.corpName)
            return
          }
          if (this.curLoginMode === 'password') {
            this.$message({type: 'success', showClose: true, message: '登录成功！跳转中...'})
          }
          this.$store.commit('corporation/SET_CORP_USERINFO', data.data)
          // 添加登录后路由
          this.$store.dispatch('addRoutes').then(() => {
            const homePath = this.routes[0].children[0].path
            this.$router.push({path: homePath})
          })
          this.$store.dispatch('setWindowTitle', 'AI 舌诊对接')
        } else {
          this.$router.push({path: this.$route.path})
        }
      })
    },
    /**
     * 企业被禁用的处理
     */
    onCorpDisabled(corpName) {
      this.$alert(`企业 ${corpName} 已被禁用，请联系云诊管理员！`, '警告', {type: 'error'})
      this.corpList = []
      this.showCorpList = false
      this.loginForm = {username: '', password: ''}
      this.$store.dispatch('LogOut').then(() => {
          this.$store.commit('SET_LOGIN_ACTIVE', 1)
          this.$store.commit('SET_LOGIN_DATA', null)
        }, (err) => {
          console.info(err)
        }
      )
    },
    goToRegister() {
      this.$store.dispatch('LogOut').then(() => {
          this.$store.commit('SET_LOGIN_ACTIVE', 1)
          this.$store.commit('SET_LOGIN_DATA', null)
          this.$router.push('/register')
        }, (err) => {
          console.info(err)
        }
      )
    },
    /**
     * 重新登录
     */
    reLogin() {
      // 退出之前的登录信息
      this.$store.dispatch('LogOut')
      this.$store.commit('SET_LOGIN_ACTIVE', 1)
      this.$store.commit('SET_LOGIN_DATA', null)
      this.showCorpList = false
      this.initWechat()
    },
    toHome() {
      window.location.href = '/'
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  height: 100%;
  background: #f5f6f7;
  color: #000;
  font-family: PingFangSC-Light, 'helvetica neue', arial, 'hiragino sans gb', 'microsoft yahei ui', 'microsoft yahei', simsun, sans-serif;

  a {
    text-decoration: none;
    color: #00a4ff;
  }

  .r-header {
    box-sizing: border-box;
    background-color: #fff;
    border-bottom: #e5e5e5 1px solid;
    padding: 6px 20px;
    height: 65px;

    .logo {
      vertical-align: middle;
      display: inline-block;
      height: 52px;
    }

    .el-button {
      float: right;
      margin-top: 6px;
    }
  }

  .t-title {
    font-size: 32px;
    line-height: 45px;
    text-align: center;
    margin-top: 40px;
    position: relative;

    h1 {
      font-size: 32px;
      font-weight: 400;
      margin: 0 auto;
      max-width: 1000px;
      position: relative;
    }
  }

  .r-wrap {
    max-width: 1000px;
    margin: 40px auto;

    .r-topbar {
      height: 76px;
      border-bottom: #e5e5e5 1px solid;
      position: relative;
      background-color: #fff;

      .r-topbar-end {
        position: absolute;
        top: 23px;
        right: 40px;

        a {
          font-size: 14px;
          line-height: 20px;
          display: inline-block;
          margin: 6px 0;
        }
      }

      .r-topbar-con {
        text-align: center;
        padding-top: 26px;

        h2 {
          display: inline-block;
          vertical-align: middle;
          font-weight: 400;
          font-size: 18px;
          line-height: 25px;
        }
      }
    }

    .r-content {
      background-color: #fff;
      padding-bottom: 40px;
      /*min-height: 500px;*/

      .login-form-wrap {
        margin: 0 auto;
        max-width: 420px;
        padding: 80px 0 20px 0;

        .login-btn {
          width: 100%;
          background-color: #00a4ff;
        }

        .qrcode_container {
          margin: auto;
          width: 300px;
          height: 310px;
        }

        .list-items {
          margin: 0;
          padding: 0 0 20px 0;
          list-style: none;
          border-top: 1px solid #f0f0f0;

          .list-item {
            padding: 16px 24px;
            border-bottom: 1px solid #f0f0f0;
            align-items: center;
            display: flex;
            cursor: pointer;
            font-size: 14px;

            span {
              float: right;
              margin-left: 6px;
            }
          }

          .list-item:hover {
            background-color: #ecf5ff;
          }
        }
      }
    }
  }

  .r-wrap-after {
    text-align: center;

    .message-wrap {
      padding: 4px 0;
      display: flex;
      justify-content: center;
      align-items: center;

      .message {
        font-size: 14px;
        color: #999;
        margin-right: 6px;
      }
    }
  }

  .lg-footer {
    width: 100%;
    text-align: center;
    padding-bottom: 50px;
    margin-top: 45px;

    .copyright {
      margin-top: 15px;

      .tag-line {
        color: #999;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue